import { createStore } from "vuex";
export default createStore({
  state: {
    deliveryInput: null,
  },
  mutations: {
    setDeliveryInput(state, deliveryInput) {
      state.deliveryInput = deliveryInput;
    },
  },
  actions: {},
  modules: {},
});
